import axios from 'axios';
import { serialize } from 'object-to-formdata';

const pathBas = '/app/vacancy_request';
const requisitionsApiEndpointsBase = '/api/requisitions';
const options = {
  indices: true
};

export const getLinkVacancyRequest = async () => {
  const response = await axios.get(`/api/requisition_link/linkVacancyRequest`);
  return response.data.response.data.url;
};

export const getActiveVacancyRequestTemplates = async () => {
  const response = await axios.post(
    '/app/configuration/get_vacancy_request_templates',
    serialize({ pageNumber: 1, pageSize: 100 })
  );

  const payload = response?.data?.response || {};
  const templates = Array.isArray(payload?.data) ? payload.data : [];
  const activeTemplates = templates.filter((template) => {
    const status = template?.status;

    if (typeof status === 'number') return status === 1;
    if (typeof status === 'string') {
      const normalizedStatus = status.toLowerCase().trim();
      return normalizedStatus === '1' || normalizedStatus === 'active' || normalizedStatus === 'activo';
    }

    return status === true;
  });
  return activeTemplates;
};

export const sendLinkVacancyRequest = async (data) => {
  const response = await axios.post(`/api/requisition_link/linkVacancySendEmail`, serialize(data));
  return response;
};

export const getNewLinkVacancyRequest = async () => {
  const response = await axios.post(`/api/requisition_link/linkVacancyRegenerate`);
  return response;
};

export const getAccountVacanciesRequests = async () => {
  const response = await axios.get(`/api/requisitions/getRequisitionCounters`);
  return response.data.response.data;
};

export const getDataTable = async (data) => {
  const response = await axios.post(`/api/requisitions/filter`, serialize(data));
  return response.data.response;
};

export const approveRequest = async (data) => {
  const response = await axios.post(`/api/requisitions/approve`, serialize(data));
  return response;
};

export const modifyRequest = async (data) => {
  const response = await axios.post(`/api/requisitions/modify`, serialize(data));
  return response;
};

export const rejectRequest = async (data) => {
  const response = await axios.post(`/api/requisitions/disapprove`, serialize(data));
  return response;
};

export const deleteRequest = async (data) => {
  const response = await axios.post(`/api/requisitions/delete`, serialize(data));
  return response;
};

export function saveNewRequest(data) {
  return axios.post(`${requisitionsApiEndpointsBase}/save_new_request`, serialize(data, options));
}

export function saveNewRequestByTemplate(data) {
  return axios.post(`${requisitionsApiEndpointsBase}/save_new_request_by_template`, serialize(data, options));
}

export const getDataForRequests = async (aliasAccount, templateHash = null, orgId = null) => {
  const params = {};
  if (templateHash) params.templateHash = templateHash;
  if (orgId) params.orgId = orgId;
  const response = await axios.get(`${pathBas}/getRequisitionFormData/${aliasAccount}`, { params });
  return response.data.dataView;
};

export const getVacancyRequestTemplateByHash = async (aliasAccount, hash) => {
  const response = await axios.get(`${pathBas}/getRequisitionTemplateByHash/${aliasAccount}/${hash}`);
  return response.data?.response?.data?.template || null;
};

export const getDefaultVacancyRequestTemplate = async (aliasAccount) => {
  const response = await axios.get(`${pathBas}/getDefaultRequisitionTemplate/${aliasAccount}`);
  return response.data?.response?.data?.template || null;
};

export const getDataShowRequest = async (idRequisition) => {
  const response = await axios.get(`/api/requisitions/getRequestVacancy/${idRequisition}`);
  return response.data.response.data;
};

export const getPublicRequisitionData = async (aliasAccount, requisitionHash) => {
  return axios.get(`/api/requisitions/getPublicRequisitionData/${aliasAccount}/${requisitionHash}`);
};

export const updateRequest = async (data) => {
  const response = await axios.post(`${requisitionsApiEndpointsBase}/update`, serialize(data, options));
  return response;
};

export const createArea = async (data) => {
  const response = await axios.post(`/app/vacancy/putAreas`, data);
  return response;
};

export const createClient = async (data) => {
  const response = await axios.post(`/app/vacancy/putClients`, data);
  return response;
};

export const getRecords = async ({ pageParam = 1, selectType }) => {
  const params = {
    pageSize: 10,
    pageNumber: pageParam,
    recordType: selectType
  };

  const response = await axios.get(`/api/requisitions/getPaginatedRecords`, { params });
  return response;
};

export const decisionRequest = async ({
  aliasAccount,
  requisitionHash,
  action,
  idRequisition,
  additionalMessage,
  sendCopy
}) => {
  const body =
    action === 'approve'
      ? { action: 'approve', idRequisition }
      : {
          action,
          idRequisition,
          ...(additionalMessage !== undefined ? { additionalMessage } : {}),
          ...(sendCopy !== undefined ? { sendCopy } : {})
        };

  try {
    const response = await axios.post(`/api/requisitions/${aliasAccount}/${requisitionHash}/decision`, body);
    return response.data;
  } catch (err) {
    const message =
      err?.response?.data?.message ||
      err?.response?.data?.error ||
      (typeof err?.response?.data === 'string' ? err.response.data : null) ||
      err?.message ||
      'Request failed';

    throw new Error(message);
  }
};
